export const DEFAULT_SORT = {
  sortBy: 'install_count',
  sortOrder: 'DESC',
}
